import { useNavigate, useRevalidator } from "react-router-dom";
import { NotFoundPage } from "@shared/components";
import { ErrorDisplay } from "./components/organisms/ErrorDisplay";
import { useErrorInfo } from "./hooks/useErrorInfo";

export const RouteErrorBoundary = () => {
  const navigate = useNavigate();
  const revalidator = useRevalidator();
  const { error, errorInfo, is404 } = useErrorInfo();

  if (is404) {
    return <NotFoundPage />;
  }

  const handleRetry = () => revalidator.revalidate();
  const handleGoBack = () => navigate(-1);

  return (
    <ErrorDisplay
      errorInfo={errorInfo}
      error={error}
      onRetry={handleRetry}
      onGoBack={handleGoBack}
    />
  );
};
